// 查询支付状态
// http://api.umucdn.cn/project/216/interface/api/3016
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { PAYMENT_RESULT_STATUS } from '@umu/umu-types';

export interface IInput {
    out_trade_no: string; // 商品唯一订单号, U202003281933003144614
}

export interface IOutput {
    out_trade_no: string; // 订单号
    product_id: string; // 商品ID
    product_subject: string; // 商品描述
    pay_amount: string; // 支付金额
    product_amount: string; // 商品金额
    pay_mode: string; // 支付方式 1-支付宝，2-paypal，3-微信
    status: PAYMENT_RESULT_STATUS; // 支付状态 0-待支付 ，1-支付中，2-支付成功，3-支付失败，4-关闭
}

// tslint:disable-next-line:max-line-length
export const queryOrder = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PAYMENT_QUERY_ORDER, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
